<template>
  <div>
    <Header />
    <h1>Pixel Test</h1>
    <div :class="$style.body">
      <div :class="$style.block">
        <p>Preview Proof notifications on a given website.</p>
        <p>
          <h3>Site to preview</h3>
          <form @submit.prevent="goToView">
            URL: <i>https://</i><input v-model="url" />
            <button type="submit" @click="goToView">Go To Preview</button>
          </form>
          <p :class="$style.note">*will not work on sites with <code>X-Frame-Options': 'sameorigin'</code></p>
        </p>
        <p>
          <h3>Submit a new conversion to display</h3>
          <div>
            <input /> <button @click="confirmConversion">Submit</button>
          </div>
        </p>
        <p :class="$style.note">*To manage this campaign, log in to staging app as:<br/>&nbsp;user: <code>marketing@useproof.com</code><br/>&nbsp;pass: <code>password</code></p>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../lib/Header'
  export default {
    name: 'PixelTest',
    components: {
      Header
    },
    data () {
      return {
        url: ''
      }
    },
    methods: {
      goToView () {
        // this.$router.push({path: 'view-test', query: {u: this.url}})
        window.location = `/view-test?u=${this.url}`
      },
      confirmConversion () {
        this.$toasted.show('Added Conversion', {
          duration: 3000,
          className: 'toasty'
        })
      }
    },
    mounted () {
      let pixel = document.createElement('script')
      pixel.setAttribute('src', 'https://cdn-staging.useproof.com/proof.js?acc=FaqmdDysP5MwCwmVmJ6DewyAKtm2')
      document.head.appendChild(pixel)
    }
  }
</script>

<style>
  iframe {
    border: none;
  }
</style>

<style lang="scss" module>
  .body {
    display: flex;
    align-items: flex-start;
    
    .block {
      flex-grow: 3;
      margin-top: 30px;
      padding: 20px 20px 40px;
      background-color: white;
      border-radius: 8px;
      -webkit-box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
      box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
      .note {
        font-size: 12px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PixelTest/index.vue